import React, { useEffect } from 'react'
// import useLoadPDFData from '../../Billing/Payments/hooks/useLoadPDFData';
import Loader from '../../shared/Loader/Loader';
import useLoadPDFDataChildWindow from '../../Billing/Payments/hooks/useLoadPDFDataChildWindow';
import useLoadPDFDataWithTypeChildWindow from '../../Billing/Payments/hooks/useLoadPFDDataWithTypeChildWindow';
import { enumUtil } from '../../../utils/Enum';

const ChildCustomScreenView = ({ dataProp }) => {
  const { isLoadingPDF, handleOpenPdf, pdfDiv } = useLoadPDFDataChildWindow();
  const { handleOpenWithPdfType, pdfDivType } = useLoadPDFDataWithTypeChildWindow();
  let objdata = dataProp.data;
  // console.log("OpenChildCustomView ChildCustomScreenView", objdata)

  useEffect(() => {

    if(dataProp.type === 'ViewEOB') {
      handleOpenPdf({ ID: objdata?.data?.id, Type: objdata?.data?.type });
    }
    if(dataProp.type === 'ViewBillingBatchDocument'){
      handleOpenWithPdfType('ViewBillingBatchDocument', objdata?.data?.bucketPath);
    }
    if(dataProp.type === 'ViewERA') {
      handleOpenWithPdfType('ViewERA', {
        Data:objdata.data.data,
        TableName:enumUtil.enumAPITableName.DownloadFile,
        Name:"TransactionInformation",
        Controller:enumUtil.controller.Payment,
        Link:"/ViewERAFile",
        Method:"post" 
      });
    }

  },[]);


  // console.log("dataProp OpenViewEOB ChildCustomScreenView", dataProp, pdfDiv);
  // const isPDFType = dataProp.type === 'ViewBillingBatchDocument';
  const isPDFType = ['ViewERA', 'ViewBillingBatchDocument'].includes(dataProp.type);
  return (
    <div>
      {/* // ViewBillingBatchDocument and add any other simple case ( Download Path ) */}
      {!isPDFType && isLoadingPDF && <Loader />}
      {isPDFType ? pdfDivType : pdfDiv}

      {/* {isLoadingPDF ? <Loader /> : null}
      {pdfDiv} */}
    </div>
  )
}

export default ChildCustomScreenView